export type FormOption = { displayValue: string; value: string };

export const primaryLanguageOptions: FormOption[] = [
  { displayValue: 'Arabic', value: 'Arabic' },
  { displayValue: 'Bengali', value: 'Bengali' },
  { displayValue: 'Bulgarian', value: 'Bulgarian' },
  { displayValue: 'Catalan', value: 'Catalan' },
  { displayValue: 'Chinese - Simplified', value: 'Chinese_Simplified' },
  { displayValue: 'Chinese - Traditional', value: 'Chinese_Traditional' },
  { displayValue: 'Croatian', value: 'Croatian' },
  { displayValue: 'Czech', value: 'Czech' },
  { displayValue: 'Danish', value: 'Danish' },
  { displayValue: 'Dutch', value: 'Dutch' },
  { displayValue: 'English - United States', value: 'English_United_States' },
  { displayValue: 'English - United Kingdom', value: 'English_United_Kingdom' },
  { displayValue: 'Estonian', value: 'Estonian' },
  { displayValue: 'Finnish', value: 'Finnish' },
  { displayValue: 'French', value: 'French' },
  { displayValue: 'German', value: 'German' },
  { displayValue: 'Greek', value: 'Greek' },
  { displayValue: 'Gujarati', value: 'Gujarati' },
  { displayValue: 'Hebrew', value: 'Hebrew' },
  { displayValue: 'Hindi', value: 'Hindi' },
  { displayValue: 'Hungarian', value: 'Hungarian' },
  { displayValue: 'Icelandic', value: 'Icelandic' },
  { displayValue: 'Indonesian', value: 'Indonesian' },
  { displayValue: 'Italian', value: 'Italian' },
  { displayValue: 'Japanese', value: 'Japanese' },
  { displayValue: 'Kannada', value: 'Kannada' },
  { displayValue: 'Korean', value: 'Korean' },
  { displayValue: 'Latvian', value: 'Latvian' },
  { displayValue: 'Lithuanian', value: 'Lituanian' },
  { displayValue: 'Malay', value: 'Malay' },
  { displayValue: 'Malayalam', value: 'Malayalam' },
  { displayValue: 'Marathi', value: 'Marathi' },
  { displayValue: 'Norwegian', value: 'Norewegian' },
  { displayValue: 'Oriya', value: 'Oriya' },
  { displayValue: 'Persian', value: 'Persian' },
  { displayValue: 'Polish', value: 'Polish' },
  { displayValue: 'Portuguese - Brazil', value: 'Portuguese_Brazil' },
  { displayValue: 'Portuguese - Portugal', value: 'Portuguese_Portugal' },
  { displayValue: 'Romanian', value: 'Romanian' },
  { displayValue: 'Russian', value: 'Russian' },
  { displayValue: 'Serbian', value: 'Serbian' },
  { displayValue: 'Slovak', value: 'Slovak' },
  { displayValue: 'Slovenian', value: 'Slovenian' },
  { displayValue: 'Spanish', value: 'Spanish' },
  { displayValue: 'Swedish', value: 'Swedish' },
  { displayValue: 'Tagalog', value: 'Tagalog' },
  { displayValue: 'Tamil', value: 'Tamil' },
  { displayValue: 'Telugu', value: 'Telugu' },
  { displayValue: 'Thai', value: 'Thai' },
  { displayValue: 'Turkish', value: 'Turkish' },
  { displayValue: 'Ukrainian', value: 'Ukranian' },
  { displayValue: 'Urdu', value: 'Urdu' },
  { displayValue: 'Vietnamese', value: 'Vietnamese' },
];

export const moderationLevelOptions: FormOption[] = [
  { displayValue: 'Moderate all messages', value: 'MODERATE_ALL_MESSAGES' },
  {
    displayValue: 'Moderate messages by new members',
    value: 'MODERATE_NEW_MEMBERS',
  },
  {
    displayValue: 'Moderate messages by non members',
    value: 'MODERATE_NON_MEMBERS',
  },
  { displayValue: `Don't moderate messages`, value: 'MODERATE_NONE' },
];

export const spamModerationLevelOptions: FormOption[] = [
  {
    displayValue:
      'Send them to the moderation queue and send notification to moderators',
    value: 'MODERATE',
  },
  {
    displayValue:
      'Send them to the moderation queue, but do not send notification to the moderators',
    value: 'SILENTLY_MODERATE',
  },
  { displayValue: 'Immediately reject them', value: 'REJECT' },
  {
    displayValue: 'Skip the moderation queue and post to the group',
    value: 'ALLOW',
  },
];

export const replyToOptions: FormOption[] = [
  { displayValue: 'To the entire group', value: 'REPLY_TO_LIST' },
  {
    displayValue: 'To the author of the message only',
    value: 'REPLY_TO_SENDER',
  },
  { displayValue: 'To the owners of the group', value: 'REPLY_TO_OWNER' },
  {
    displayValue: 'To the managers of the group',
    value: 'REPLY_TO_MANAGERS',
  },
  {
    displayValue: 'Users decide where their replies are sent',
    value: 'REPLY_TO_IGNORE',
  },
  {
    displayValue: 'Use a custom address to send replies to',
    value: 'REPLY_TO_CUSTOM',
  },
];

export const whoCanViewGroupOptions: FormOption[] = [
  { displayValue: 'Group owners', value: 'ALL_OWNERS_CAN_VIEW' },
  { displayValue: 'Group managers', value: 'ALL_MANAGERS_CAN_VIEW' },
  { displayValue: 'Group members', value: 'ALL_MEMBERS_CAN_VIEW' },
  { displayValue: 'Entire organization', value: 'ALL_IN_DOMAIN_CAN_VIEW' },
  { displayValue: 'Anyone on the web', value: 'ANYONE_CAN_VIEW' },
];

export const whoCanPostMessageOptions: FormOption[] = [
  { displayValue: 'Group owners', value: 'ALL_OWNERS_CAN_POST' },
  { displayValue: 'Group managers', value: 'ALL_MANAGERS_CAN_POST' },
  { displayValue: 'Group members', value: 'ALL_MEMBERS_CAN_POST' },
  { displayValue: 'Entire organization', value: 'ALL_IN_DOMAIN_CAN_POST' },
  { displayValue: 'Anyone on the web', value: 'ANYONE_CAN_POST' },
  { displayValue: 'None can post', value: 'NONE_CAN_POST' },
];

export const whoCanViewMembersOptions: FormOption[] = [
  { displayValue: 'Group Owners', value: 'ALL_OWNERS_CAN_VIEW' },
  { displayValue: 'Group managers', value: 'ALL_MANAGERS_CAN_VIEW' },
  { displayValue: 'Group members', value: 'ALL_MEMBERS_CAN_VIEW' },
  { displayValue: 'Entire organization', value: 'ALL_IN_DOMAIN_CAN_VIEW' },
];

export const whoCanModerateMembersOptions: FormOption[] = [
  { displayValue: 'Group Owners', value: 'OWNERS_ONLY' },
  { displayValue: 'Group managers', value: 'OWNERS_AND_MANAGERS' },
  { displayValue: 'Group members', value: 'ALL_MEMBERS' },
  { displayValue: 'None', value: 'NONE' },
];

export const whoCanModerateContentOptions: FormOption[] = [
  { displayValue: 'Group Owners', value: 'OWNERS_ONLY' },
  { displayValue: 'Group managers', value: 'OWNERS_AND_MANAGERS' },
  { displayValue: 'Group members', value: 'ALL_MEMBERS' },
  { displayValue: 'None', value: 'NONE' },
];

export const whoCanAssistContentOptions: FormOption[] = [
  { displayValue: 'Group Owners', value: 'OWNERS_ONLY' },
  { displayValue: 'Group managers', value: 'OWNERS_AND_MANAGERS' },
  { displayValue: 'Group members', value: 'ALL_MEMBERS' },
  { displayValue: 'None', value: 'NONE' },
];

export const whoCanLeaveGroupOptions: FormOption[] = [
  { displayValue: 'Group Owners', value: 'ALL_OWNERS_CAN_LEAVE' },
  { displayValue: 'Group managers', value: 'ALL_MANAGERS_CAN_LEAVE' },
  { displayValue: 'Group members', value: 'ALL_MEMBERS_CAN_LEAVE' },
  { displayValue: 'None', value: 'NONE_CAN_LEAVE' },
];

export const inviteMembersOptions: FormOption[] = [
  { displayValue: 'Anyone on the web can join', value: 'ANYONE_CAN_JOIN' },
  {
    displayValue: 'Organization users only',
    value: 'ALL_IN_DOMAIN_CAN_JOIN',
  },
  {
    displayValue: 'Organization users can ask',
    value: 'CAN_REQUEST_TO_JOIN',
  },
  { displayValue: 'Invited users only', value: 'INVITED_CAN_JOIN' },
];

export const whoCanContactOwnerOptions: FormOption[] = [
  { displayValue: 'Group managers', value: 'ALL_MANAGERS_CAN_CONTACT' },
  { displayValue: 'Group members', value: 'ALL_MEMBERS_CAN_CONTACT' },
  { displayValue: 'Entire organization', value: 'ALL_IN_DOMAIN_CAN_CONTACT' },
  { displayValue: 'Anyone on the web', value: 'ANYONE_CAN_CONTACT' },
];

export const whoCanDiscoverGroupOptions: FormOption[] = [
  { displayValue: 'Group members', value: 'ALL_MEMBERS_CAN_DISCOVER' },
  {
    displayValue: 'Entire organization',
    value: 'ALL_IN_DOMAIN_CAN_DISCOVER',
  },
  { displayValue: 'Anyone on the web', value: 'ANYONE_CAN_DISCOVER' },
];
